// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.title__BalanceWidget-module--Adtzb {
    font-size: calc(var(--px) * 22);
    font-weight: 800;
    letter-spacing: -0.01em;
    color: var(--color-text-primary);
}

.scale__BalanceWidget-module--tjFKL {
    position: relative;
    width: calc(var(--px) * 244);
    height: calc(var(--px) * 118);
}

.stand__BalanceWidget-module--fwsJR {
    position: absolute;
    left: calc(var(--px) * 92);
    top: calc(var(--px) * 44);
    width: calc(var(--px) * 60);
    height: calc(var(--px) * 74);
    border-radius: calc(var(--px) * 30) calc(var(--px) * 30) calc(var(--px) * 10) calc(var(--px) * 10);
    background: var(--color-neutral-700);
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: calc(var(--px) * 8);
    gap: calc(var(--px) * 6);
}

.gauge__BalanceWidget-module--zNIAh {
    position: relative;
    width: calc(var(--px) * 38);
    height: calc(var(--px) * 38);
    border-radius: 50%;
    background: var(--color-neutral-50);
}

.needle__BalanceWidget-module--kZ2U3 {
    position: absolute;
    left: 50%;
    top: calc(var(--px) * 5);
    width: calc(var(--px) * 3);
    height: calc(var(--px) * 16);
    margin-left: calc(var(--px) * -1.5);
    border-radius: calc(var(--px) * 2);
    background: var(--color-feedback-correct);
}

.gaugeDot__BalanceWidget-module--jY7qo {
    position: absolute;
    left: 50%;
    top: 50%;
    width: calc(var(--px) * 14);
    height: calc(var(--px) * 14);
    margin: calc(var(--px) * -4) 0 0 calc(var(--px) * -7);
    border-radius: 50%;
    background: var(--color-feedback-correct-tint);
}

.balancedLabel__BalanceWidget-module--Y9j47 {
    font-size: calc(var(--px) * 8);
    font-weight: 800;
    letter-spacing: 0.06em;
    color: var(--color-feedback-correct-tint);
}

.beam__BalanceWidget-module--JLBtC {
    position: absolute;
    left: calc(var(--px) * 14);
    right: calc(var(--px) * 14);
    top: calc(var(--px) * 56);
    height: calc(var(--px) * 6);
    border-radius: calc(var(--px) * 3);
    background: var(--color-neutral-800);
}

.trayBar__BalanceWidget-module--j7skd {
    position: absolute;
    top: calc(var(--px) * 50);
    width: calc(var(--px) * 104);
    height: calc(var(--px) * 8);
    border-radius: 999px;
    background: var(--color-neutral-600);
}

.trayBarLeft__BalanceWidget-module--JjvVt {
    left: 0;
}

.trayBarRight__BalanceWidget-module--cWIlH {
    right: 0;
}

.tray__BalanceWidget-module--IdiuG {
    position: absolute;
    bottom: calc(var(--px) * 68);
    width: calc(var(--px) * 96);
    display: flex;
    flex-wrap: wrap-reverse;
    justify-content: center;
    gap: calc(var(--px) * 2);
}

.trayLeft__BalanceWidget-module--dByA8 {
    left: calc(var(--px) * 4);
}

.trayRight__BalanceWidget-module--zgD5l {
    right: calc(var(--px) * 4);
}

.nBlock__BalanceWidget-module--zVVnL {
    width: calc(var(--px) * 18);
    height: calc(var(--px) * 18);
    border-radius: calc(var(--px) * 4);
    background: var(--color-primary-200);
    border: calc(var(--px) * 1.5) solid var(--color-primary-600);
    color: var(--color-primary-900);
    font-size: calc(var(--px) * 11);
    font-weight: 800;
    font-style: italic;
    display: flex;
    align-items: center;
    justify-content: center;
}

.unit__BalanceWidget-module--u399d {
    width: calc(var(--px) * 16);
    height: calc(var(--px) * 16);
    border-radius: 50%;
    background: var(--home-color-orange);
    border: calc(var(--px) * 1.5) solid var(--color-neutral-900);
    color: var(--color-text-primary);
    font-size: calc(var(--px) * 9);
    font-weight: 800;
    display: flex;
    align-items: center;
    justify-content: center;
}

.removable__BalanceWidget-module--Uzj4f {
    opacity: 0;
    transform: translateY(calc(var(--px) * -26)) scale(0.5);
}

.gone1__BalanceWidget-module--RKgo6 {
    animation: gone1__BalanceWidget-module--RKgo6 8s ease-in-out infinite;
}

.gone2__BalanceWidget-module--zvoA0 {
    animation: gone2__BalanceWidget-module--zvoA0 8s ease-in-out infinite;
}

@keyframes gone1__BalanceWidget-module--RKgo6 {
    0%, 22% {
        opacity: 1;
        transform: none;
    }
    28%, 92% {
        opacity: 0;
        transform: translateY(calc(var(--px) * -26)) scale(0.5);
    }
    100% {
        opacity: 1;
        transform: none;
    }
}

@keyframes gone2__BalanceWidget-module--zvoA0 {
    0%, 36% {
        opacity: 1;
        transform: none;
    }
    42%, 92% {
        opacity: 0;
        transform: translateY(calc(var(--px) * -26)) scale(0.5);
    }
    100% {
        opacity: 1;
        transform: none;
    }
}

.answerRow__BalanceWidget-module--Vfnux {
    display: flex;
    align-items: center;
    gap: calc(var(--px) * 8);
    font-size: calc(var(--px) * 20);
    font-weight: 800;
    color: var(--color-text-primary);
}

.answerBox__BalanceWidget-module--sMGpC {
    width: calc(var(--px) * 48);
    height: calc(var(--px) * 40);
    border-radius: calc(var(--px) * 10);
    border: calc(var(--px) * 1.5) solid var(--color-neutral-400);
    background: var(--color-neutral-50);
    display: flex;
    align-items: center;
    justify-content: center;
}

.answerDigit__BalanceWidget-module--WsbOh {
    opacity: 1;
}

.tick__BalanceWidget-module--qceEM {
    opacity: 1;
}

.rise__BalanceWidget-module--yonS5 {
    animation: rise__BalanceWidget-module--yonS5 8s ease-out infinite;
}

.pop__BalanceWidget-module--Ox4al {
    animation: pop__BalanceWidget-module--Ox4al 8s ease-out infinite;
}

@keyframes rise__BalanceWidget-module--yonS5 {
    0%, 53% {
        opacity: 0;
        transform: translateY(calc(var(--px) * 12));
    }
    58%, 92% {
        opacity: 1;
        transform: none;
    }
    100% {
        opacity: 0;
    }
}

@keyframes pop__BalanceWidget-module--Ox4al {
    0%, 56% {
        opacity: 0;
        transform: scale(0.3);
    }
    61% {
        opacity: 1;
        transform: scale(1.18);
    }
    65%, 90% {
        opacity: 1;
        transform: scale(1);
    }
    96%, 100% {
        opacity: 0;
        transform: scale(0.8);
    }
}
`, "",{"version":3,"sources":["webpack://./src/main/ui/home/components/BalanceWidget.module.css"],"names":[],"mappings":"AAAA;IACI,+BAA+B;IAC/B,gBAAgB;IAChB,uBAAuB;IACvB,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;IAClB,4BAA4B;IAC5B,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;IAClB,0BAA0B;IAC1B,yBAAyB;IACzB,2BAA2B;IAC3B,4BAA4B;IAC5B,kGAAkG;IAClG,oCAAoC;IACpC,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,gCAAgC;IAChC,wBAAwB;AAC5B;;AAEA;IACI,kBAAkB;IAClB,2BAA2B;IAC3B,4BAA4B;IAC5B,kBAAkB;IAClB,mCAAmC;AACvC;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,wBAAwB;IACxB,0BAA0B;IAC1B,4BAA4B;IAC5B,mCAAmC;IACnC,kCAAkC;IAClC,yCAAyC;AAC7C;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,2BAA2B;IAC3B,4BAA4B;IAC5B,qDAAqD;IACrD,kBAAkB;IAClB,8CAA8C;AAClD;;AAEA;IACI,8BAA8B;IAC9B,gBAAgB;IAChB,sBAAsB;IACtB,yCAAyC;AAC7C;;AAEA;IACI,kBAAkB;IAClB,0BAA0B;IAC1B,2BAA2B;IAC3B,yBAAyB;IACzB,2BAA2B;IAC3B,kCAAkC;IAClC,oCAAoC;AACxC;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,4BAA4B;IAC5B,2BAA2B;IAC3B,oBAAoB;IACpB,oCAAoC;AACxC;;AAEA;IACI,OAAO;AACX;;AAEA;IACI,QAAQ;AACZ;;AAEA;IACI,kBAAkB;IAClB,4BAA4B;IAC5B,2BAA2B;IAC3B,aAAa;IACb,uBAAuB;IACvB,uBAAuB;IACvB,wBAAwB;AAC5B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,2BAA2B;IAC3B,4BAA4B;IAC5B,kCAAkC;IAClC,oCAAoC;IACpC,4DAA4D;IAC5D,+BAA+B;IAC/B,+BAA+B;IAC/B,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,2BAA2B;IAC3B,4BAA4B;IAC5B,kBAAkB;IAClB,oCAAoC;IACpC,4DAA4D;IAC5D,gCAAgC;IAChC,8BAA8B;IAC9B,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,UAAU;IACV,uDAAuD;AAC3D;;AAEA;IACI,qEAAwC;AAC5C;;AAEA;IACI,qEAAwC;AAC5C;;AAEA;IACI;QACI,UAAU;QACV,eAAe;IACnB;IACA;QACI,UAAU;QACV,uDAAuD;IAC3D;IACA;QACI,UAAU;QACV,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,UAAU;QACV,eAAe;IACnB;IACA;QACI,UAAU;QACV,uDAAuD;IAC3D;IACA;QACI,UAAU;QACV,eAAe;IACnB;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,wBAAwB;IACxB,+BAA+B;IAC/B,gBAAgB;IAChB,gCAAgC;AACpC;;AAEA;IACI,2BAA2B;IAC3B,4BAA4B;IAC5B,mCAAmC;IACnC,4DAA4D;IAC5D,mCAAmC;IACnC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,iEAAoC;AACxC;;AAEA;IACI,gEAAmC;AACvC;;AAEA;IACI;QACI,UAAU;QACV,2CAA2C;IAC/C;IACA;QACI,UAAU;QACV,eAAe;IACnB;IACA;QACI,UAAU;IACd;AACJ;;AAEA;IACI;QACI,UAAU;QACV,qBAAqB;IACzB;IACA;QACI,UAAU;QACV,sBAAsB;IAC1B;IACA;QACI,UAAU;QACV,mBAAmB;IACvB;IACA;QACI,UAAU;QACV,qBAAqB;IACzB;AACJ","sourcesContent":[".title {\n    font-size: calc(var(--px) * 22);\n    font-weight: 800;\n    letter-spacing: -0.01em;\n    color: var(--color-text-primary);\n}\n\n.scale {\n    position: relative;\n    width: calc(var(--px) * 244);\n    height: calc(var(--px) * 118);\n}\n\n.stand {\n    position: absolute;\n    left: calc(var(--px) * 92);\n    top: calc(var(--px) * 44);\n    width: calc(var(--px) * 60);\n    height: calc(var(--px) * 74);\n    border-radius: calc(var(--px) * 30) calc(var(--px) * 30) calc(var(--px) * 10) calc(var(--px) * 10);\n    background: var(--color-neutral-700);\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    padding-top: calc(var(--px) * 8);\n    gap: calc(var(--px) * 6);\n}\n\n.gauge {\n    position: relative;\n    width: calc(var(--px) * 38);\n    height: calc(var(--px) * 38);\n    border-radius: 50%;\n    background: var(--color-neutral-50);\n}\n\n.needle {\n    position: absolute;\n    left: 50%;\n    top: calc(var(--px) * 5);\n    width: calc(var(--px) * 3);\n    height: calc(var(--px) * 16);\n    margin-left: calc(var(--px) * -1.5);\n    border-radius: calc(var(--px) * 2);\n    background: var(--color-feedback-correct);\n}\n\n.gaugeDot {\n    position: absolute;\n    left: 50%;\n    top: 50%;\n    width: calc(var(--px) * 14);\n    height: calc(var(--px) * 14);\n    margin: calc(var(--px) * -4) 0 0 calc(var(--px) * -7);\n    border-radius: 50%;\n    background: var(--color-feedback-correct-tint);\n}\n\n.balancedLabel {\n    font-size: calc(var(--px) * 8);\n    font-weight: 800;\n    letter-spacing: 0.06em;\n    color: var(--color-feedback-correct-tint);\n}\n\n.beam {\n    position: absolute;\n    left: calc(var(--px) * 14);\n    right: calc(var(--px) * 14);\n    top: calc(var(--px) * 56);\n    height: calc(var(--px) * 6);\n    border-radius: calc(var(--px) * 3);\n    background: var(--color-neutral-800);\n}\n\n.trayBar {\n    position: absolute;\n    top: calc(var(--px) * 50);\n    width: calc(var(--px) * 104);\n    height: calc(var(--px) * 8);\n    border-radius: 999px;\n    background: var(--color-neutral-600);\n}\n\n.trayBarLeft {\n    left: 0;\n}\n\n.trayBarRight {\n    right: 0;\n}\n\n.tray {\n    position: absolute;\n    bottom: calc(var(--px) * 68);\n    width: calc(var(--px) * 96);\n    display: flex;\n    flex-wrap: wrap-reverse;\n    justify-content: center;\n    gap: calc(var(--px) * 2);\n}\n\n.trayLeft {\n    left: calc(var(--px) * 4);\n}\n\n.trayRight {\n    right: calc(var(--px) * 4);\n}\n\n.nBlock {\n    width: calc(var(--px) * 18);\n    height: calc(var(--px) * 18);\n    border-radius: calc(var(--px) * 4);\n    background: var(--color-primary-200);\n    border: calc(var(--px) * 1.5) solid var(--color-primary-600);\n    color: var(--color-primary-900);\n    font-size: calc(var(--px) * 11);\n    font-weight: 800;\n    font-style: italic;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.unit {\n    width: calc(var(--px) * 16);\n    height: calc(var(--px) * 16);\n    border-radius: 50%;\n    background: var(--home-color-orange);\n    border: calc(var(--px) * 1.5) solid var(--color-neutral-900);\n    color: var(--color-text-primary);\n    font-size: calc(var(--px) * 9);\n    font-weight: 800;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.removable {\n    opacity: 0;\n    transform: translateY(calc(var(--px) * -26)) scale(0.5);\n}\n\n.gone1 {\n    animation: gone1 8s ease-in-out infinite;\n}\n\n.gone2 {\n    animation: gone2 8s ease-in-out infinite;\n}\n\n@keyframes gone1 {\n    0%, 22% {\n        opacity: 1;\n        transform: none;\n    }\n    28%, 92% {\n        opacity: 0;\n        transform: translateY(calc(var(--px) * -26)) scale(0.5);\n    }\n    100% {\n        opacity: 1;\n        transform: none;\n    }\n}\n\n@keyframes gone2 {\n    0%, 36% {\n        opacity: 1;\n        transform: none;\n    }\n    42%, 92% {\n        opacity: 0;\n        transform: translateY(calc(var(--px) * -26)) scale(0.5);\n    }\n    100% {\n        opacity: 1;\n        transform: none;\n    }\n}\n\n.answerRow {\n    display: flex;\n    align-items: center;\n    gap: calc(var(--px) * 8);\n    font-size: calc(var(--px) * 20);\n    font-weight: 800;\n    color: var(--color-text-primary);\n}\n\n.answerBox {\n    width: calc(var(--px) * 48);\n    height: calc(var(--px) * 40);\n    border-radius: calc(var(--px) * 10);\n    border: calc(var(--px) * 1.5) solid var(--color-neutral-400);\n    background: var(--color-neutral-50);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.answerDigit {\n    opacity: 1;\n}\n\n.tick {\n    opacity: 1;\n}\n\n.rise {\n    animation: rise 8s ease-out infinite;\n}\n\n.pop {\n    animation: pop 8s ease-out infinite;\n}\n\n@keyframes rise {\n    0%, 53% {\n        opacity: 0;\n        transform: translateY(calc(var(--px) * 12));\n    }\n    58%, 92% {\n        opacity: 1;\n        transform: none;\n    }\n    100% {\n        opacity: 0;\n    }\n}\n\n@keyframes pop {\n    0%, 56% {\n        opacity: 0;\n        transform: scale(0.3);\n    }\n    61% {\n        opacity: 1;\n        transform: scale(1.18);\n    }\n    65%, 90% {\n        opacity: 1;\n        transform: scale(1);\n    }\n    96%, 100% {\n        opacity: 0;\n        transform: scale(0.8);\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"title": `title__BalanceWidget-module--Adtzb`,
	"scale": `scale__BalanceWidget-module--tjFKL`,
	"stand": `stand__BalanceWidget-module--fwsJR`,
	"gauge": `gauge__BalanceWidget-module--zNIAh`,
	"needle": `needle__BalanceWidget-module--kZ2U3`,
	"gaugeDot": `gaugeDot__BalanceWidget-module--jY7qo`,
	"balancedLabel": `balancedLabel__BalanceWidget-module--Y9j47`,
	"beam": `beam__BalanceWidget-module--JLBtC`,
	"trayBar": `trayBar__BalanceWidget-module--j7skd`,
	"trayBarLeft": `trayBarLeft__BalanceWidget-module--JjvVt`,
	"trayBarRight": `trayBarRight__BalanceWidget-module--cWIlH`,
	"tray": `tray__BalanceWidget-module--IdiuG`,
	"trayLeft": `trayLeft__BalanceWidget-module--dByA8`,
	"trayRight": `trayRight__BalanceWidget-module--zgD5l`,
	"nBlock": `nBlock__BalanceWidget-module--zVVnL`,
	"unit": `unit__BalanceWidget-module--u399d`,
	"removable": `removable__BalanceWidget-module--Uzj4f`,
	"gone1": `gone1__BalanceWidget-module--RKgo6`,
	"gone2": `gone2__BalanceWidget-module--zvoA0`,
	"answerRow": `answerRow__BalanceWidget-module--Vfnux`,
	"answerBox": `answerBox__BalanceWidget-module--sMGpC`,
	"answerDigit": `answerDigit__BalanceWidget-module--WsbOh`,
	"tick": `tick__BalanceWidget-module--qceEM`,
	"rise": `rise__BalanceWidget-module--yonS5`,
	"pop": `pop__BalanceWidget-module--Ox4al`
};
export default ___CSS_LOADER_EXPORT___;
